import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const totalVegaGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX_Total_Vanna',
      metainfo: {
        metainfoVersion: 53,
        id: "SPX Total Vanna@tv-basicstudies-1",
        description: "SPX Total Vanna",
        shortDescription: "SPX Total Vanna",
        linkedToSeries: true,
        is_price_study: false,
        format: { type: "price" },
        plots: [
          {
            id: "net_vega",
            type: "line",
            title: "Net Vega",
            trackPrice: true,
            transparency: 70,
            fillGaps: true
          },
          {
            id: "zero_line",
            type: "line",
            title: "Zero Line"
          }
        ],
        defaults: {
          styles: {
            net_vega: {
              linestyle: 0,
              linewidth: 1,
              plottype: 8,
              trackPrice: false,
              transparency: 60,
              visible: true,
              color: "#06f598",
              color2: "#FF4500",
            },
            zero_line: {
              linestyle: 0,
              linewidth: 1,
              color: "#ffffff",
              visible: true
            }
          },
          precision: 2,
          inputs: {}
        },
        styles: {
          net_vega: { title: "Net Vega", histogramBase: 8 },
          zero_line: { title: "Zero Line" }
        },
        inputs: []
      },
      constructor: function () {
        this._debugMode = true;

        this.init = function (ctx) {
          this._context = ctx;
        };

        this.main = function (ctx) {
          try {
            const { greekExposures } = useGreeksWebsocketDataStore.getState();
            const spxExposures = greekExposures.spx;

            if (!spxExposures?.length) {
              if (this._debugMode) {
                // console.log('[totalVegaGetter] No greek exposures data');
              }
              return [null, null];
            }

            const time = ctx.symbol.time;
            if (!time || isNaN(time)) {
              if (this._debugMode) {
                // console.log('[totalVegaGetter] Invalid symbol time:', time);
              }
              return [null, null];
            }

            const timeInSec = Math.floor(time / 1000);

            const vegaExposures = spxExposures
              .filter(exp => exp.greek_type === 'vega')
              .sort((a, b) => a.timestamp - b.timestamp);

            if (!vegaExposures.length) {
              return [null, null];
            }

            let closestExp = vegaExposures[0];
            let minDiff = Math.abs(closestExp.timestamp - timeInSec);

            for (const exp of vegaExposures) {
              const diff = Math.abs(exp.timestamp - timeInSec);

              if (diff < minDiff) {
                minDiff = diff;
                closestExp = exp;
              }
            }

            const value = parseFloat(closestExp.net_exposure) || 0;

            return [value, 0];  // Return both the vega value and zero line
          } catch (err) {
            return [null, null];
          }
        };

        this.destroy = function() {
          // No cleanup needed since we're not using subscriptions
        };
      }
    }
  ]);
};